import { render, staticRenderFns } from "./MissApprove.vue?vue&type=template&id=6265a52c&scoped=true"
import script from "./MissApprove.vue?vue&type=script&lang=js"
export * from "./MissApprove.vue?vue&type=script&lang=js"
import style0 from "./MissApprove.vue?vue&type=style&index=0&id=6265a52c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6265a52c",
  null
  
)

export default component.exports